(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["book-sound"] && !Shopify.designMode) return;
  try {
    const formatTime = (seconds) => {
      const total = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
      const minutes = Math.floor(total / 60);
      return `${minutes}:${String(total % 60).padStart(2, '0')}`;
    };

    class BookSound extends HTMLElement {
      connectedCallback() {
        this.audio = this.querySelector('audio');
        this.button = this.querySelector('button');
        this.labelEl = this.querySelector('.book-sound__label');
        this.timeEl = this.querySelector('.book-sound__time');

        if (!this.audio || !this.button) return;

        if (!this.timeEl) {
          console.warn('[book-sound] .book-sound__time introuvable, le compteur ne sera pas mis a jour.', this);
        }

        this.labelIdle = this.dataset.labelIdle || (this.labelEl ? this.labelEl.textContent : '');
        this.labelPlaying = this.dataset.labelPlaying || this.labelIdle;
        this.duration = 0;

        this.button.addEventListener('click', () => this.toggle());
        this.audio.addEventListener('loadedmetadata', () => this.resolveDuration());
        this.audio.addEventListener('durationchange', () => this.resolveDuration());
        this.audio.addEventListener('timeupdate', () => this.renderTime());
        this.audio.addEventListener('play', () => this.setPlaying(true));
        this.audio.addEventListener('pause', () => this.setPlaying(false));
        this.audio.addEventListener('error', () => {
          console.warn('[book-sound] fichier audio illisible:', this.audio.currentSrc);
        });
        this.audio.addEventListener('ended', () => {
          this.audio.currentTime = 0;
          this.setPlaying(false);
          this.renderTime();
        });

        if (this.audio.readyState >= 1) this.resolveDuration();
        this.renderTime();
      }

      disconnectedCallback() {
        this.pause();
      }

      resolveDuration() {
        const reported = this.audio.duration;

        if (Number.isFinite(reported) && reported > 0) {
          this.duration = reported;
          this.renderTime();
          return;
        }

        if (reported !== Infinity || this.durationProbed) return;

        // MP3 VBR ou WebM sans en-tete de duree : on force le navigateur a la calculer
        // en cherchant au-dela de la fin, puis on revient au debut.
        this.durationProbed = true;

        try {
          this.audio.currentTime = 1e101;
        } catch (error) {
          return;
        }

        this.audio.addEventListener(
          'timeupdate',
          () => {
            if (Number.isFinite(this.audio.duration)) this.duration = this.audio.duration;
            this.audio.currentTime = 0;
            this.renderTime();
          },
          { once: true }
        );
      }

      toggle() {
        if (!this.audio.paused) {
          this.audio.pause();
          return;
        }

        document.querySelectorAll('book-sound').forEach((player) => {
          if (player !== this) player.pause();
        });

        this.audio.play().catch(() => this.setPlaying(false));
      }

      pause() {
        if (this.audio && !this.audio.paused) this.audio.pause();
      }

      setPlaying(isPlaying) {
        this.classList.toggle('is-playing', isPlaying);
        this.button.setAttribute('aria-pressed', String(isPlaying));
        if (this.labelEl) this.labelEl.textContent = isPlaying ? this.labelPlaying : this.labelIdle;
      }

      renderTime() {
        if (!this.timeEl) return;

        const elapsed = formatTime(this.audio.currentTime);

        if (!this.duration) {
          this.timeEl.textContent = elapsed;
          return;
        }

        this.timeEl.textContent = `${elapsed} / ${formatTime(this.duration)}`;
      }
    }

    if (!customElements.get('book-sound')) {
      customElements.define('book-sound', BookSound);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-conformity-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-conformity-open]');
    if (!trigger) return;
    var panel = document.querySelector('.product-caracteristiques .tabs--content.downloads');
    if (!panel) return;
    var anchor = document.querySelector('.product-caracteristiques .tabs--container') || panel;
    var top = anchor.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });
    // Le composant des onglets n'est chargé qu'à l'approche de sa section : on attend qu'il soit prêt.
    customElements.whenDefined('tabs-selector').then(function () {
      var tab = document.querySelector('.product-caracteristiques .tab--nav-item[data-index="' + panel.dataset.index + '"]');
      if (tab) tab.click();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
